module.exports = __webpack_public_path__ + "img/jinshukuai01-600.0ca35e48.png";